import { ServiceRoute } from '../../../../types';

export class ServiceRoutesBuilder {
  constructor(private readonly serviceRoutes: ServiceRoute[]) {}

  addRoute(text: string, value: string, icon: string): ServiceRoutesBuilder {
    this.serviceRoutes.push({ text, value, icon });
    return this;
  }

  build(): ServiceRoute[] {
    return this.serviceRoutes;
  }
}
